export const GOAL_CREATED = "GOAL_CREATED";
export const CREATE_GOAL_SUCCESS = "CREATE_GOAL_SUCCESS";
export const UPDATE_GOAL_SUCCESS = "UPDATE_GOAL_SUCCESS";
export const DELETE_GOAL_SUCCESS = "DELETE_GOAL_SUCCESS";
export const LOAD_GOALS_SUCCESS = "LOAD_GOALS_SUCCESS";
export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";
